<template>
  <div class="index-documenti-mobile">
    <!--<header-app :counterNuovi="counterNuovi"></header-app>-->
      <!-- <div class="titolo-app col-24 no-padding">
          <span class="titolo-bold hidden-xs">
            {{ $t($route.meta.appName).label }}
          </span>
      </div> -->

      <div class="contenitore col-24">
        <!-- <menu-app></menu-app> -->

        <div class="row row-custom doc-title" :style="{ height: '50px'}">
          <div class="col-24 no-padding select-wrapper">
            <select v-model="tipoDoc">
              <option v-for="(app, index) in apps" :value="app" :key="index">
                {{ getLabel(app.label[0]) }}
              </option>
            </select>
          </div>
        </div>
        <div class="row row-custom doc-content">
          <comunicazioni v-if="objComunicazione.tipologia == 'COM'" class="col-24  no-padding" :style="{ height: (contenitoreHeight - 50) + 'px'}"
                       :contenitoreHeight="contenitoreHeight" :key="objComunicazione.codice" :objComunicazione="objComunicazione"></comunicazioni>
          <modulistica v-if="objComunicazione.tipologia == 'MOD'" class="col-24  no-padding" :style="{ height: (contenitoreHeight - 50) + 'px'}"
                       :contenitoreHeight="contenitoreHeight" :key="objComunicazione.codice" :objComunicazione="objComunicazione"></modulistica>
        </div>
      </div>

  </div>

</template>

<script>
  import {bus} from '../Bus.js'
  import Comunicazioni from './Comunicazioni.vue'
  import Modulistica from './Modulistica.vue'

  export default {
    components: {
      Comunicazioni,
      Modulistica
    },
    props: {
      area: {
        type: String,
        default: 'documenti'
      },
      contenitoreHeight: {
        type: Number
      },
      contentWidth: {
        type: Number
      }
    },
    name: 'IndexDocumenti',
    data () {
      return {
        loading: false,
        showScroll: true,
        menuApps: [],
        menu: {},
        apps: [],
        areaProva: this.area,
        tipoDoc: '',
        objComunicazione: {},
        codLang: ''
      }
    },
    watch: {
      '$store.state.menu.codiApp': function (to, from) {
        this.initialize()
      },
      tipoDoc: function (app) {
        if (app.codice !== undefined && app.codice !== '')
          this.$set(this, 'objComunicazione', app)
      },
    },
    /*watch: {
      tipoDoc: function () {
        if (this.tipoDoc !== '' && this.tipoDoc !== this.$route.name)
          this.$router.push({name: this.tipoDoc})
      },
      '$route.meta.appName': function (to, from) {
        if (!this._inactive)
          this.initialize()
      }
    },*/
    mounted: function () {
      bus.$on('changeLanguage', () => {
        this.codLang = sessionStorage.getItem('codLang')
      })

    },
    activated: function () {
      this.initialize()
    },
    deactivated: function () {
      this.$set(this,'tipoDoc', '')
    },
    methods: {
      initialize: function () {
        this.codLang = sessionStorage.getItem('codLang')
        this.$set(this, 'menuApps', this.$store.state.menu)
        this.$set(this, 'objComunicazione', {})
        this.getMenu()
      },
      getMenu: function () {
        this.loading = true
         var obj = {
          params: {
            codiApp: this.menuApps.codiApp
          }
        }
        this.$http.get('dipendente/' + this.$store.state.country + '/docMenu', obj).then(response => {
          this.$set(this, 'apps', response.body.data)
          this.loading = false
        })
      },
      link: function () {
        this.$set(this, 'objComunicazione', app)
      },
      docStyle: function (docType) {
        // console.log(docType)
        let name = this.$route.name
        return docType === name ? true : false
      },
      getLabel: function (label) {
        if (label === undefined || label === null) {
          return "ERROR"
        } else {
          return label[this.codLang]
        }
      }
    }
  }
</script>

<style lang="less">
  @import "../../assets/less/general.less";

  .index-documenti-mobile {
    height: 100%;
    .titolo-app {
      padding-left: 5px;
      .set-font(@size: 15px; @color: @greenRiva);
      text-transform: uppercase;
      letter-spacing: 2px;
      overflow: hidden;
      height: 50px;
      line-height: 50px;
      .titolo-bold {
        font-weight: 700;
      }
    }
    .icone {
      padding-top: 10px;
      .icona {
        text-align: center;
        .icona-menu {
          padding-left: 0px;
          padding-right: 3px;
          text-align: right;
          display: inline-block;
          vertical-align: middle;
        }
        .label-menu {
          .set-font(@size: 12px; @weight: bold);
          text-align: center;
          display: inline-block;
          vertical-align: middle;
        }
      }
      .icona:hover {
        cursor: pointer;
      }
    }
    .contenitore {
      overflow: hidden;
      padding-left: 5px;
      padding-right: 5px;
      .doc-title {
        height: 70px;
        // position: fixed;
    	  // background-color: white;
        // z-index: 100;

        .select-wrapper {
          position: relative;
          display: inline-block;
          &:after {
            content: '\0025BC';
            // font: normal normal normal 12px/1 FontAwesome;
            color: #cbb385;
            right: 8%;
            top: -3px;
            height: 26px;
            padding: 15px 0px 0px 8px;
            position: absolute;
            pointer-events: none;
          }
          select {
            .set-font(@size: 18px, @weight: bold, @color: @textTable, @family: 'os-bold');
            width: 90%;
            padding-right: 24px;
            background-color: #fff;
            border-radius: 5px;
            border-color: #cbb385;
            //font-family: Arial, ArialHebrew, sans-serif;
            //font-size: 18px;
            text-align: -moz-center;
            text-align: -webkit-center;
            text-align: center !important;
            //color: #cbb385;
            margin: 3px;
            padding: 3px;
            -webkit-appearance: none;
            &:focus {
              outline: none;
            }
          }
        }

        /*select {
          height: 40px;
          //font-family: 'os-lightitalic';
          font-weight: bold;
          font-size: 16px;
          color: #cbb385;
          text-align: center;
          background-color: #ffffff;
         
        }*/
      }
      .doc-content {
        // padding-top: 50px;
      }
    }
    .box-left {
      border-right: 1px solid @greyLine;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Documenti/IndexDocumentiMobile.vue